module.exports = __webpack_public_path__ + "static/media/photolist-empty.d2ddbbf6.png";